module.exports = __webpack_public_path__ + "img/tg_01 (2).f2b279fd.jpg";